export const getInitials = (name, type = '') => {
    if (!name) return '';

    let processedName = name.trim();

    if (type === 'organization') {
        processedName = processedName.replace(/ and /gi, ' ').replace(/&/g, ' ').replace(/-/g, ' ');
    }

    const nameParts = processedName.split(' ');

    const firstInitial = nameParts[0]?.charAt(0).toUpperCase() || '';
    const secondInitial = nameParts[1]?.charAt(0).toUpperCase() || '';

    return `${firstInitial}${secondInitial}`;
};
